import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 1 1 0 18a9 9 0 0 1 0 -18z","key":"svg-0"}],["path",{"d":"M6 12a6 6 0 0 1 6 -6","key":"svg-1"}]]

const IconInnerShadowTopLeft = createReactComponent('outline', 'inner-shadow-top-left', 'InnerShadowTopLeft', __iconNode);

export default IconInnerShadowTopLeft;